// extracted by mini-css-extract-plugin
export default {"mainContainer":"Contact_mainContainer__eTLkj","backgroundImageContainer":"Contact_backgroundImageContainer__khGu-"};